import currency from 'currency.js';
import { NumericString } from './typescript';

export const amountToUsd = (amount?: number | NumericString) => amount ? currency(amount).format() : null;

export const amountToKhr = (amount?: number | NumericString) =>
  amount ? currency(amount, { pattern: '# ៛', precision: 0 }).format() : null;

export const formatCurrency = (amount?: number | NumericString) => {
  if (amount === undefined || amount === null) return '$0.00';
  return `$${Number(amount).toFixed(2)}`;
};

export const formatPercentage = (percent?: number | NumericString, precision = 1) => {
  if (percent === undefined || percent === null) return `0.${'0'.repeat(precision)}%`;
  return `${Number(percent).toFixed(precision)}%`;
};
